import(/* webpackMode: "eager", webpackExports: ["AnalyzeTabsRow"] */ "/opt/buildhome/repo/web-app/frontend/src/components/AnalyzeTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/SharedHeader.tsx");
